// Function to format a number with commas
export const formatNumber = (number) => {

  return new Intl.NumberFormat("en").format(number || 0);
};

// Custom tick formatter for YAxis
export const formatNumberToK = (tick) => {
  if (tick >= 1000000) {
    return `${(tick / 1000000).toFixed(1)}M`; // Format as millions
  } else if (tick >= 1000) {
    return `${(tick / 1000).toFixed(1)}k`; // Format as thousands
  }
  return formatNumber(tick); // Return the number as-is if less than 1k
};

// Function to trim input value
export const trimInputValue = (value, limit) => {

  return value?.slice(0, limit);
};
 